'use strict';

// Pinch+zoom image component

var _ = require('lodash');
var Classnames = require('classnames');
var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var SuperAgent = require('superagent');

var IndexRoute = ReactRouter.IndexRoute;
var Route      = ReactRouter.Route;
var Router     = ReactRouter.Router;
var Link       = ReactRouter.Link;

var Components = require('../components');
var Constants  = require('../constants');
var Global     = require('../global');

var isNode = typeof document === 'undefined';
if (!isNode) {
    var Hammer = require('hammerjs');
    require('./image.scss');
}

var Media = Components.Media;
var ParseAPI = Global.ParseAPI;
var ResponsiveMixin = Global.ResponsiveMixin;

var Image = React.createClass({
    mixins: [ ResponsiveMixin ],

    getInitialState: function() {
        var fromProduct = (this.props.location.state && this.props.location.state.fromProduct) ?
            this.props.location.state.fromProduct : null;
        return {
            // width,height,title,filename,returnURL - see image.php
            image: null,

            // fromProduct is passed to Image to set the Close link target
            fromProduct: fromProduct,
        };
    },
    componentDidMount: function() {
        if (isNode)
            return;
        var _this = this;

        // Disable native scrolling
        document.ontouchmove = function(ev) {
            ev.preventDefault();
        };

        var query = {
            imageID: this.props.params.imageID,
        };

        SuperAgent
            .get(`/image/${this.props.params.imageID}.json`)
            .query(query)
            .end(function(err, res) {
                var image = ParseAPI(query, err, res);
                _this.setState({
                    image: image,
                }, function() {
                    _this._didLoad();
                });
            });

    },
    componentWillUnmount: function() {
        document.ontouchmove = null;
    },
    _didLoad: function() {
        // Setup initial state
        this.init();

        // Register gesture recognizer
        var dom = ReactDOM.findDOMNode(this.refs.img);
        var mc = new Hammer.Manager(dom, {
            recognizers: [
                [ Hammer.Pinch, { enable: true }],
                [ Hammer.Pan ],
            ],
        });
        mc.on('pinch pan', (ev) => {
            this.handleZoom(ev);
        });
    },
    componentDidUpdate: function(prevProps, prevState) {
        if (this.image && this.state.viewportWidth != prevState.viewportWidth) {
            this.init();
        }
    },
    init: function() {
        var paneHeight = ReactDOM.findDOMNode(this.refs.pane).offsetHeight;

        var width = Math.min(this.state.image.width, this.state.viewportWidth);

        var aspect = this.state.image.width / this.state.image.height;
        var height = width / aspect;

        if (height > paneHeight) {
            height = paneHeight;
            width = aspect * height;
        }

        var originX = width / 2;
        var originY = paneHeight / 2;

        this.setState({
            init: true, // false for first render to get viewport dimensions

            paneHeight: paneHeight,

            // = (width / height)
            aspect:     aspect,

            // Size of image as rendered on viewport
            width:      width,
            height:     height,

            // Center of image on viewport
            originX:    originX,
            originY:    originY,

            // Updated at the end of each gesture (all fingers lifted)
            width_last: width,
            height_last: height,
            originX_last: originX,
            originY_last: originY,

            left: originX - width / 2,
            top: originY - height / 2,
        });
    },
    handleZoom: function(ev) {
        if (this.state.image.width < this.state.viewportWidth) {
            return;
        }

        var newWidth = this.state.width_last * ev.scale;
        var newHeight = this.state.height_last * ev.scale;

        newWidth = Math.min(newWidth, this.state.image.width);
        newHeight = Math.min(newHeight, this.state.image.height);

        if (newWidth < this.state.viewportWidth) {
            newWidth = this.state.viewportWidth;
            newHeight = newWidth / this.state.aspect;
        }

        var newOriginX = this.state.originX_last + ev.deltaX;
        var newOriginY = this.state.originY_last + ev.deltaY;

        var left = newOriginX - newWidth / 2;
        var top = newOriginY - newHeight / 2;
        
        // Don't allow left edge of image to be inset into viewport - keep 'camera view' within image bounds
        left = Math.min(0, left);

        // And similarly for right edge
        var right = newOriginX + newWidth / 2;
        if (right < this.state.viewportWidth) {
            left = this.state.viewportWidth - newWidth;
        }

        var paneHeight = this.state.paneHeight;

        if (newHeight < paneHeight) {
            // If shorter than viewport, don't allow top of image to be moved off screen
            top = Math.max(0, top);

            // And similar for bottom
            if (top + newHeight > paneHeight) {
                top -= (top + newHeight - paneHeight);
            }
        } else {
            // If taller than viewport, keep 'camera view' within image bounds
            top = Math.min(0, top);
            var bottom = top + newHeight;
            if (top + newHeight < paneHeight) {
                top = paneHeight - newHeight;
            }
        }

        newOriginX = left + newWidth / 2;
        newOriginY = top + newHeight / 2;

        var state = {
            width: newWidth,
            originX: newOriginX,
            originY: newOriginY,

            left: left,
            top: top,
        };
        if (ev.srcEvent.type == 'touchend') {
            if (newHeight < this.state.paneHeight) {
                // Spring short image back to vertical center of screen
                state = _.merge(state, {
                    width_last: newWidth,
                    height_last: newHeight,
                    originX_last: newOriginX,

                    originY: this.state.paneHeight / 2,
                    originY_last: this.state.paneHeight / 2,
                    top: this.state.paneHeight / 2 - newHeight / 2,
                });
            } else {
                state = _.merge(state, {
                    width_last: newWidth,
                    height_last: newHeight,
                    originX_last: newOriginX,
                    originY_last: newOriginY,
                });
            }
        }

        this.setState(state);
    },
    _goBack: function(ev) {
        if (!isNode) {
            window.history.back();
        }
    },
    render: function() {
        if (!this.state.image) {
            return <div />
        }

        var imageStyle = {
            left: this.state.left,
            top: this.state.top,
            width: this.state.width,
            // height: this.state.height,
        };
        return (
            <div className='image'>
                <div className='image-header'>
                    {this.state.image.title  ?
                        <div className='image-title'>
                            {this.state.image.title}
                        </div>
                    : null}
                    {this.state.fromProduct ?
                        <button className='image-close' onClick={this._goBack}>
                            <img src={Constants.static + 'images/global/close/close-grey2.png'} />
                        </button>
                    : this.state.image.returnURL ?
                            <Link className='image-close' to={this.state.image.returnURL}>
                                <img src={Constants.static + 'images/global/close/close-grey2.png'} />
                            </Link>
                    : null}
                </div>
                <div className='image-content' ref='pane'>
                    <img className='image-img' style={imageStyle} ref='img' src={Payload.release.media + this.state.image.filename} />
                </div>
            </div>
        );
    },
});

module.exports = Image;



// WEBPACK FOOTER //
// ./src/collections/image.jsx